import React from 'react';
import { useTheme } from '../context/ThemeContext';
import Footer from '../components/Footer';
import ProtectedEmail from '../components/ProtectedEmail';
import styles from '../styles/Privacidad.module.css';

const AvisoLegal = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`${styles.container} ${isDarkMode ? styles.dark : ''}`}>
      <main className={styles.main}>
        <div className={`${styles.contentContainer} ${isDarkMode ? styles.dark : ''}`}>
          <h1 className={styles.title}>Aviso Legal - ExamenCAP</h1>
          
          <p className={styles.lastUpdated}>Última actualización: 26 de febrero de 2025</p>
          
          <section>
            <h2>1. Información del Titular</h2>
            <p>
              En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI), se exponen a continuación los datos identificativos del titular:
            </p>
            <ul>
              <li><strong>Titular</strong>: Ramon Asen Pons Miralles</li>
              <li><strong>NIF/DNI</strong>: 43208755N</li>
              <li><strong>Domicilio</strong>: Calle Eusebio Estada 29, 8A, 07004, Palma de Mallorca, Islas Baleares, España</li>
              <li><strong>Contacto</strong>: <ProtectedEmail email="contacto@examencap.es" linkText="contacto@examencap.es" /></li>
            </ul>
          </section>
          
          <section>
            <h2>2. Objeto y Ámbito de Aplicación</h2>
            <p>
              El presente Aviso Legal regula el uso del sitio web examencap.es (en adelante, el "Sitio Web"), del que es titular Ramon Asen Pons Miralles.
            </p>
            <p>
              La navegación por el Sitio Web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal, que pueden sufrir modificaciones.
            </p>
          </section>
          
          <section>
            <h2>3. Propiedad Intelectual e Industrial</h2>
            <p>
              Todos los contenidos del Sitio Web, incluyendo, a título enunciativo pero no limitativo, textos, gráficos, imágenes, su diseño y los códigos fuente utilizados, están sujetos a derechos de propiedad intelectual de los que es titular Ramon Asen Pons Miralles o terceros que han autorizado su inclusión.
            </p>
            <p>
              Queda expresamente prohibida la reproducción total o parcial de este Sitio Web, ni de cualquiera de sus contenidos, sin el permiso expreso y por escrito de Ramon Asen Pons Miralles.
            </p>
          </section>
          
          <section>
            <h2>4. Condiciones de Uso</h2>
            
            <h3>4.1 General</h3>
            <p>
              El usuario se compromete a utilizar el Sitio Web, los servicios y los contenidos de conformidad con la Ley, el presente Aviso Legal, las buenas costumbres y el orden público.
            </p>
            
            <h3>4.2 Acceso y Seguridad</h3>
            <p>
              El acceso al Sitio Web no implica obligación alguna por parte del titular de controlar la ausencia de virus o cualquier otro elemento informático dañino. Corresponde al usuario disponer de herramientas adecuadas para la detección y desinfección de programas informáticos dañinos.
            </p>
            
            <h3>4.3 Conducta del Usuario</h3>
            <p>
              El usuario se compromete a no realizar actividades que puedan dañar, sobrecargar, deteriorar o impedir la normal utilización del Sitio Web, los equipos informáticos, los documentos, archivos y toda clase de contenidos almacenados.
            </p>
          </section>
          
          <section>
            <h2>5. Responsabilidad</h2>
            
            <h3>5.1 Del Titular</h3>
            <p>
              El titular no garantiza la disponibilidad y continuidad del funcionamiento del Sitio Web. Cuando sea razonablemente posible, el titular advertirá previamente de las interrupciones en el funcionamiento del Sitio Web.
            </p>
            <p>
              El titular excluye cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse a la falta de disponibilidad o de continuidad del funcionamiento del Sitio Web.
            </p>
            
            <h3>5.2 Por Contenidos</h3>
            <p>
              El titular no se hace responsable de la información y contenidos almacenados, a título enunciativo pero no limitativo, en foros, chats, generadores de blogs, comentarios, redes sociales o cualquier otro medio que permita a terceros publicar contenidos de forma independiente en el Sitio Web.
            </p>
            
            <h3>5.3 Por Enlaces a Terceros</h3>
            <p>
              En el caso de que en el Sitio Web se dispusiesen enlaces o hipervínculos hacia otros sitios de Internet, el titular no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso el titular asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno.
            </p>
          </section>
          
          <section>
            <h2>6. Política de Privacidad</h2>
            <p>
              Para más información sobre el tratamiento de datos personales y la política de privacidad, consulte nuestra <a href="/privacidad">Política de Privacidad</a>.
            </p>
          </section>
          
          <section>
            <h2>7. Cookies</h2>
            <p>
              El Sitio Web puede utilizar cookies (pequeños archivos de información que el servidor envía al ordenador de quien accede a la página) para llevar a cabo determinadas funciones que son consideradas imprescindibles para el correcto funcionamiento y visualización del sitio. Para más información, consulte nuestra <a href="/cookies">Política de Cookies</a>.
            </p>
          </section>
          
          <section>
            <h2>8. Legislación Aplicable y Jurisdicción</h2>
            <p>
              Las presentes Condiciones se regirán e interpretarán de acuerdo con la legislación española.
            </p>
            <p>
              Para la resolución de todas las controversias o cuestiones relacionadas con el presente Sitio Web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales de Palma de Mallorca, España.
            </p>
          </section>
          
          <div className={styles.disclaimer}>
            <p>Este aviso legal ha sido elaborado en cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI).</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AvisoLegal;